var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHexLife(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 42,
    viewBox: "0 0 41 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.94469 35.0819C5.01643 35.4028 5.25901 35.6581 5.57581 35.7462L24.6375 41.0475C24.9394 41.1314 25.2632 41.0507 25.4904 40.8349L40.2771 26.7877C40.5043 26.5719 40.6015 26.2527 40.5331 25.9469L36.216 6.63847C36.1443 6.31757 35.9017 6.06222 35.5849 5.97412L16.5232 0.672902C16.2213 0.588948 15.8975 0.669646 15.6703 0.885454L0.883602 14.9326C0.656431 15.1484 0.559241 15.4677 0.62761 15.7734L4.94469 35.0819Z",
    fill: "#9A4799"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexLife);
export default __webpack_public_path__ + "static/media/hexLife.c78186ddb0683410610ff58cb4855366.svg";
export { ForwardRef as ReactComponent };